import { apiClient } from "./apiClient";

let csrfToken: string | null = null;

export async function fetchCsrfToken(): Promise<void> {
	try {
		const response = await apiClient("auth/csrf-token", { getRawResponse: true });
		if (response.ok) {
			const json = await response.json();
			csrfToken = json?.data?.token ?? json?.csrfToken ?? json?.token ?? null;
		}
	} catch {
		// silently ignore — CSRF fetch failure should not crash the app
	}
}

export function getCsrfToken(): string | null {
	return csrfToken;
}
